import React from "react";
import { connect } from "react-redux";

import {
  setGameState,
  setScoreBox,
  setTheaterMode,
  setUser,
  setUserAuthStatus,
  TArkadiumSdkStore,
} from "../../store/reducers";

import { HttpError } from "../../../fetch";
import { MobileQuery } from "../../atoms/Layout/Responsive";
import { Ribbon } from "../../atoms/Ribbon/Ribbon";
import { GameState } from "../../models/Enums";
import { Game } from "../../models/Game";
import { ScoreBoxModel } from "../../models/ScoreBoxModel";
import { User } from "../../models/User";
import { UserAuthStatus } from "../../models/UserAuthStatus";
import { ScoreFilterModel } from "../../models/ScoreFilterModel";
import { Preroll } from "../../molecules/Preroll/Preroll";
import { Analytics } from "../../services/Analytics/Analytics";
import LocalScoreService from "../../services/LocalScoreService";
import RemoteScoreService from "../../services/RemoteScoreService";
import ScoreService from "../../services/RemoteScoreService";
import RecentlyPlayedService from "../../services/RecentlyPlayedService";
import { UserService } from "../../services/UserService";
import { MarkersKeys, MeasureService } from "../../services/MeasureService";
import { InvitaionService } from "../../services/InvitaionService";
import { BadgeService } from "../../services/BadgeService";
import { GameEnd } from "../GameEnd/GameEnd";
import { GameUnit } from "./GameUnit";
import { GameCover } from "./GameCover";
import { getBadgeByGame } from "../../constants/Badges";
import {
  isSkipPlayNowScreen,
  isSkipPreroll,
} from "../../constants/CustomGamePlayFlow";
import styles from "./Game.css";
import classNames from "classnames";
import { RewardVideo } from "../../molecules/RewardVideo/RewardVideo";
import FriendApiService from "../../services/Friend/FriendApiService";
import {
  checkFullPath,
  IframeMessageTypes,
  isLandscape,
  isMobileDevice,
  isServer,
  postMessageToIframe,
} from "../../../utils";
import { RewardLabel } from "../../atoms/RewardLabel/RewardLabel";
import { AnalyticsAttribute } from "./AnalyticsAttribute";
import Modal from "../../atoms/Modal/Modal";
import { CoverBlock } from "./CoverBlock";
import { CrossPromotionService } from "../../services/CrossPromotionService";
import { EngagementPromoService } from "../../services/EngagementPromoService";
import AARPAuthService from "../../services/AARPAuthService";
import { UrlService } from "../../services/UrlService";
import { getAspectRatioByGame } from "../../constants/GameAspectRatioData";
import { Subject } from "../../models/GameObservable";
import ThemeSettings from "../../../theme";
import {
  ResizeBox,
  handlerADContent,
} from "../../molecules/ResizeBox/ResizeBox";
import { environment } from "../../config/environment";
import { isMobile } from "../../services/DeviceDetector";
import GameMobileAd from "../../molecules/GameMobileAd/GameMobileAd";
import { PreviewModeService } from "../../services/PreviewModeService";
import { EnumIframeMessageTypes, GameRenderingModule, TypeGRMProps as GRMProps, TypeEnvType, TypeGameEvent, TypeUserModel } from "@arkadium/modules";
import { SDK_ENV, ARENA_ENV } from "../../templates/Game/Game";

const gameStates = [
  GameState.GAME,
  GameState.REWARD,
  GameState.GAME_END,
  GameState.GAME_SCORE_SAVED,
  GameState.PREROLL,
  GameState.COVER_MEMBER,
  GameState.COVER_LOGGED_IN,
  GameState.COVER_PREVIEW_MODE,
  GameState.COVER_SKIP_PREROLL,
  GameState.PENDING,
];

type GameContainerProps = {
  userAuthStatus: UserAuthStatus;
  game: Game;
  user: User;
  gameState: GameState;
  scoreBox: ScoreBoxModel;
  scoreFilter: ScoreFilterModel[];
  dispatch?: any;
  isTheaterMode: boolean;
  isDisplayAdsEnabled: boolean;
  gamePreviews: any;
  sdkLoaded: TArkadiumSdkStore;
};

interface RootState {
  gameState: GameState;
  scoreBox: ScoreBoxModel;
  scoreFilter: ScoreFilterModel[];
  userAuthStatus: UserAuthStatus;
  isTheaterMode: boolean;
  gamePreviews: any;
  sdkLoaded: TArkadiumSdkStore;
}

const END_PREROLL = "arkadium:endPreroll";
let didGameEnded = false;
let isGameScoreHacked = false;

class GameContainerDumb extends React.PureComponent<GameContainerProps> {
  state = {
    score: 0,
    highScore: 0,
    isSaveScoreToLeaderboard: true,
    scoreToShow: 0,
    showRewardVideoModal: false,
    showMemberOnlyModal: false,
    crossPromotion: null,
    engagementPromo: null,
    previewMode: null,
    showLoginPowerUpModal: false,
    showOptInToRewardModal: false,
    showLoginModal: false,
    isPhone: isMobile(),
    isLandscape: null,
  };

  gameStartTime: any = -1;
  private rewardPayload: any = null;
  private powerUpPayload: any = null;
  gameContainerRef = React.createRef<HTMLDivElement>();
  gameSubject: Subject = new Subject(this);

  doSetGameObservable = (gameSubject: any) => {
    this.gameSubject = gameSubject;
  };

  onGameLoad = () => {
    this.setState({ isGameLoading: false });
    // FOR TRIVIA HARD CODE
    const url = new URL((window as any).location.href);

    (window as any).arenaName = "AARP";

    if (
      url.searchParams.get("toGo") &&
      (this.props.game.slug === "aarp-trivia" ||
        this.props.game.slug === "aarp-trivia-sports")
    ) {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("ExternalPrerollEnd"));
      }, 3000);
    }
  };

  sendScoreAfterLogin() {
    const lastGameScore = LocalScoreService.getScoreIfLoginToSave();

    if (lastGameScore) {
      // Concat both last game score and previous local scores
      const localScores = LocalScoreService.getScoresAsArray();
      localScores.push(lastGameScore);

      RemoteScoreService.saveScores(localScores)
        .then(() =>
          RemoteScoreService.patchLBWithUserScore(
            this.props.game.groupSlug,
            this.props.user,
            lastGameScore.value
          )
        )
        .then(() => {
          LocalScoreService.clearLocalScores();
          this.props.dispatch(setGameState(GameState.GAME_SCORE_SAVED));
        });

      this.props.dispatch(setGameState(GameState.GAME_END));
      this.setState({ score: lastGameScore.value || 0 });

      (window as any).history.pushState(
        "",
        "",
        (window as any).location.pathname
      );
    } else {
      this.props.dispatch(setGameState(this.getDefaultState()));
    }
  }

  // FOR TRIVIA HARD CODE
  hasTriviaToGoParam(): boolean {
    const url = new URL((window as any).location.href);

    return url.searchParams.get("toGo") &&
      (this.props.game.slug === "aarp-trivia" ||
        this.props.game.slug === "aarp-trivia-sports");
  }

  getDefaultState(): GameState {
    if (InvitaionService.isInvitaionLink(this.props.game)) {
      this.triggerAARPExternalEvent();
      return UserService.isUserAuthorized(this.props.user)
        ? GameState.PREROLL
        : GameState.GAME;
    }

    if (
      UserService.gameForMemberIsUnavailable(
        this.props.user,
        this.props.game,
        !!this.getPreviewMode()
      )
    ) {
      return GameState.COVER_MEMBER;
    }

    if (
      this.getPreviewMode() &&
      !UserService.isUserAuthorized(this.props.user)
    ) {
      return GameState.COVER_PREVIEW_MODE;
    }

    if (isSkipPreroll(this.props.game.slug)) {
      return GameState.COVER_SKIP_PREROLL;
    }

    if (this.hasTriviaToGoParam()) {
      return GameState.GAME;
    }
    // const url = new URL((window as any).location.href);
    // if (url.searchParams.get("continueGame")) {
    //   return GameState.GAME;
    // }

    return isSkipPlayNowScreen(this.props.game.slug)
      ? GameState.GAME
      : GameState.PREROLL;
  }

  checkAuth() {
    switch (this.props.userAuthStatus) {
      case UserAuthStatus.PENDING:
        this.props.dispatch(setGameState(GameState.PENDING));
        break;
      case UserAuthStatus.USER_NOT_AUTHORIZED:
        this.props.dispatch(setGameState(this.getDefaultState()));
        break;
      case UserAuthStatus.USER_AUTHORIZED:
        this.sendScoreAfterLogin();
        break;
      default:
        break;
    }
  }

  receiveMessage = (event) => {
    try {
      const userEvent = JSON.parse(event.data);
      if (userEvent.event === END_PREROLL) {
        this.props.dispatch(setGameState(GameState.GAME));
      }
    } catch (_) {
      return _;
    }
  };

  getScoreBox() {
    if (UserService.isUserAuthorized(this.props.user)) {
      ScoreService.getScoreBox(this.props.game.groupSlug).then((scoreBox) =>
        this.props.dispatch(setScoreBox(scoreBox))
      );
    }
  }

  async getCrossPromotion() {
    const { game } = this.props;
    const crossPromotion = await CrossPromotionService.getPromoByDateAndGameID(
      game.slug
    );
    return this.setState({ crossPromotion });
  }

  async getEngagementPromotion() {
    const { game } = this.props;
    const engagementPromo =
      await EngagementPromoService.getPromoByDateAndGameID(game.slug);
    return this.setState({ engagementPromo });
  }

  getPreviewMode() {
    const { game, gamePreviews } = this.props;
    if (!gamePreviews) return null;

    const previewMode = PreviewModeService.getPreviewByDateAndGameSlug(
      gamePreviews,
      game.slug
    );
    this.setState({ previewMode });
    return previewMode;
  }

  isScoreHacked(slug: string, score: number): boolean {
    const gameMaxScore = this.props.scoreFilter.find(
      (item) => item.slug === slug
    );
    return gameMaxScore && gameMaxScore.maxScore < score;
  }

  saveScore(slug: string, score: number) {
    if (UserService.isUserAuthorized(this.props.user)) {
      RemoteScoreService.saveScores([{ slug, value: score }])
        .then(() =>
          RemoteScoreService.patchLBWithUserScore(slug, this.props.user, score)
        )
        .then(() =>
          this.props.dispatch(setGameState(GameState.GAME_SCORE_SAVED))
        )
        .catch((err) => {
          // Save score locally for both cases
          LocalScoreService.saveScore(slug, score);

          // Redirect User if he became unauthorized - token expired, secret changed
          if (err instanceof HttpError && err.response.status === 401) {
            // Force Login To Save Score
            LocalScoreService.initLoginToSaveScore({ slug, value: score });
          } else {
            this.props.dispatch(setUser(null));
            this.props.dispatch(
              setUserAuthStatus(UserAuthStatus.USER_NOT_AUTHORIZED)
            );
            throw err;
          }
        });
    } else {
      LocalScoreService.saveScore(slug, score);
    }
  }

  saveScorePromise: any = (slug: string, score: number) => {
    //prevent multiplay save score
    if (this.saveScorePromise.result) {
      return this.saveScorePromise.result;
    }

    this.saveScorePromise.result = new Promise<void>((resolve) => {
      //is game score was hacked
      if (this.isScoreHacked(slug, score)) {
        isGameScoreHacked = true;
      } else {
        //external save score if game was not hacked
        this.saveScore(slug, score);
        this.rewardBadge(slug, score);
      }

      //internal save score to state for showing in GameEnd
      this.setState({ score });
      resolve();
    });

    return this.saveScorePromise.result;
  };

  onScoreChange = (event) => {
    const score = parseInt(event.payload);
    const slug = this.props.game.groupSlug;
    this.saveScorePromise(slug, score);
  };

  onGameEnd = (event) => {
    if (didGameEnded) {
      return;
    }

    const pload = event.payload;
    if (
      pload &&
      pload.puzzleId &&
      pload.puzzleDate &&
      pload.saveScoreToLeaderboard
    ) {
      FriendApiService.saveScoreByPuzzle(
        pload.puzzleDate,
        pload.puzzleId,
        this.props.game.slug,
        pload.score
      );
    }

    if (pload && !pload.saveScoreToLeaderboard) {
      this.setState({ isSaveScoreToLeaderboard: pload.saveScoreToLeaderboard });
      this.setState({ scoreToShow: pload.score });
    }

    Analytics.trackEvent(
      Analytics.games.gameEnd(
        this.props.game,
        Date.now() - this.gameStartTime,
        this.state.score,
        this.props.isTheaterMode
      )
    );

    this.props.dispatch(setGameState(GameState.GAME_END));
    didGameEnded = true;
  };

  onReward = (event: any) => {
    const { game } = this.props; 
    const env = SDK_ENV[environment.AARP_ENV as keyof typeof SDK_ENV];

    const options = { duration: 30, env };
    this.rewardPayload = event.payload;

    
    if (game.seo_IsRewardInModal && this.rewardPayload.data) {
      this.setState({ showRewardVideoModal: true });
      return;
    }
    this.props.dispatch(setGameState(GameState.REWARD));

    this.props.sdkLoaded?.ads?.showRewardAd(options).then(() => {
			requestAnimationFrame(() => this.onRewardEnd());
		});
  };

  onRewardEnd = () => {
    if (this.grmIsUsed()) {
      //Needed for GRM games
      postMessageToIframe({
        type: IframeMessageTypes.REWARD_CALLBACK,
        payload: { hasReward: true },
      });
    } else if (this.rewardPayload && this.rewardPayload.callback) {
      this.rewardPayload.callback({ hasReward: true });
    }

    this.props.dispatch(setGameState(GameState.GAME));
  };

  onPowerUp = (event: any) => {
    const { user } = this.props;
    this.powerUpPayload = event.payload;
    
    if (user) {
      this.getOptInToRewardsStatus();
      return;
    }

    this.setState({
      showLoginPowerUpModal: true,
    });
  };

  onOptInLogin = (event: any) => {
    this.powerUpPayload = event.payload;

    this.setState({
      showLoginPowerUpModal: true,
    });
  };

  getOptInToRewardsStatus = () => {
    if (
      window["AARP"].store.getState().cookie.at &&
      window["AARP"].store.getState().cookie.at.rs &&
      window["AARP"].store.getState().cookie.at.rs == "Y"
    ) {
      if (this.grmIsUsed()) {
        //Needed for GRM games
        postMessageToIframe({
          type: IframeMessageTypes.POWERUP_CALLBACK,
          payload: { isOptInToReward: true },
        });
      } else if (this.powerUpPayload && this.powerUpPayload.callback) {
        this.powerUpPayload.callback({ isOptInToReward: true });
      } else {
        console.error("Power Up Callback is not defined");
      }
    } else {
      this.setState({ showOptInToRewardModal: true });
    }
  };

  loginPowerUpModal() {
    return (
      <Modal
        header="AARP REWARDS PARTICIPANT FEATURE"
        headerTitle="Log in to access these AARP Rewards PowerUps"
        footerText="New to Rewards? Get Started >"
        onClose={() => this.handlerCloseLoginPowerUpModal()}
        onConfirm={() => this.handlerLoginPowerUpModal()}
        footerClick={() => this.handlerRegisterPowerUpModal()}
        confirmButtonText="Log In"
        hasBorder
        isSectionModal
        modalTheme="powerUps"
      />
    );
  }
  optInToRewardModal() {
    return (
      <Modal
        header="AARP REWARDS PARTICIPANT FEATURE"
        headerTitle="Log in to access these AARP Rewards PowerUps"
        footerText="New to Rewards? Get Started > "
        onClose={() => this.handlerCloseOptInModal()}
        onConfirm={() => this.handlerLoginPowerUpModal()}
        footerClick={() => this.handlerRegisterPowerUpModal()}
        confirmButtonText="Log In"
        isSectionModal
        hasBorder
        modalTheme="powerUps"
      />
    );
  }

  handlerCloseLoginPowerUpModal() {
    if (this.grmIsUsed()) {
      //Needed for GRM games
      postMessageToIframe({
        type: IframeMessageTypes.POWERUP_CALLBACK,
        payload: undefined,
      });
    } else if (this.powerUpPayload && this.powerUpPayload.callback) {
      this.powerUpPayload.callback(undefined);
    }

    this.setState({ showLoginPowerUpModal: false });
  }

  handlerLoginPowerUpModal() {
    location.href = AARPAuthService.getPowerUpRedirectURL({
      redirectType: "login",
    });
  }

  handlerRegisterPowerUpModal() {
    location.href = AARPAuthService.getPowerUpRedirectURL({
      redirectType: "register",
    });
  }

  handlerCloseOptInModal() {
    //Needed for GRM games
    postMessageToIframe({
      type: IframeMessageTypes.POWERUP_CALLBACK,
      payload: undefined,
    });
    if (this.powerUpPayload && this.powerUpPayload.callback) {
      this.powerUpPayload.callback(undefined);
    }
    this.setState({ showOptInToRewardModal: false });
  }

  rewardVideoModal() {
    return (
      <Modal
        modalTheme="primary"
        headerTitle="Watch the Video Bonus now"
        content={`to earn ${
          this.rewardPayload && this.rewardPayload.data.count
            ? this.rewardPayload.data.count
            : ""
        } extra game points!`}
        onClose={() => this.handlerCloseRewardVideoModal()}
        onConfirm={() => this.handlerRewardVideoModal()}
        confirmButtonText="Watch Now"
        hasHeaderImage
        headerImageSrc="/images/ic_movi_3.png"
        footerText="Go back to game >"
        footerClick={() => this.handlerCloseRewardVideoModal()}
        isSectionModal={!isMobileDevice()}
        memberOnlyGrayBar
        confirmButtonSize="lg"
        isContentBold
      />
    );
  }
  handlerCloseRewardVideoModal() {
    postMessageToIframe({
      type: IframeMessageTypes.REWARD_CALLBACK,
      payload: undefined,
    });
    if (this.rewardPayload && this.rewardPayload.callback) {
      this.rewardPayload.callback(undefined);
    }
    this.setState({ showRewardVideoModal: false });
  }
  handlerRewardVideoModal() {
    const { user } = this.props;
    this.setState({ showRewardVideoModal: false });

    if (user && UserService.isValidMember(user)) {
      this.props.dispatch(setGameState(GameState.REWARD));
      return;
    }
    this.setState({
      showMemberOnlyModal: true,
    });
  }

  memberOnlyModal() {
    return (
      <CoverBlock
        slug={this.props.game.slug}
        gameName={this.props.game.seo_GameName}
        gameState={GameState.COVER_MEMBER}
        onClose={() => this.handlerCloseMemberOnlyModal()}
        isRewardVideoModal
      />
    );
  }
  handlerCloseMemberOnlyModal() {
    this.setState({ showMemberOnlyModal: false });
    this.setState({ showRewardVideoModal: true });
    return;
  }

  rewardBadge(slug: string, score: any) {
    try {
      const badge = getBadgeByGame(slug);
      if (badge) {
        const duration = (Date.now() - this.gameStartTime) / 1000;
        if (
          badge.MinScore <= score &&
          badge.MaxScore >= score &&
          badge.Duration <= duration
        ) {
          window.dispatchEvent(new CustomEvent("badge-activity-complete"));
        }
      }
    } catch (e) {
      console.error("Badge error");
    }
  }

  triggerAARPExternalEvent = () => {
    const badge = getBadgeByGame(this.props.game.slug);
    if (badge) {
      window.dispatchEvent(new CustomEvent("ExternalPrerollEnd"));
    }
  };

  onPrerollEnd = () => {
    performance.mark(MarkersKeys.GameStart);

    let pe = MeasureService.measure(
      this.props.game,
      MarkersKeys.PlayGameClick,
      MarkersKeys.GameStart
    );
    if (pe) {
      Analytics.trackEvent(
        Analytics.games.performanceMeasure(this.props.game, pe)
      );
      MeasureService.clearMeasures(pe);
    }

    pe = MeasureService.measure(
      this.props.game,
      MarkersKeys.EndOfPreroll,
      MarkersKeys.GameStart
    );
    if (pe) {
      Analytics.trackEvent(
        Analytics.games.performanceMeasure(this.props.game, pe)
      );
      MeasureService.clearMeasures(pe);
    }

    pe = MeasureService.measure(
      this.props.game,
      MarkersKeys.PlayAgainClick,
      MarkersKeys.GameStart
    );
    if (pe) {
      Analytics.trackEvent(
        Analytics.games.performanceMeasure(this.props.game, pe)
      );
      MeasureService.clearMeasures(pe);
    }

    MeasureService.clearMarks();

    this.gameStartTime = Date.now();
    Analytics.trackEvent(
      Analytics.games.gameStart(this.props.game, this.props.isTheaterMode)
    );
    this.props.dispatch(setGameState(GameState.GAME));

    // update Badge Reward popup status. AARP remove popup for phone (Rewards Framing Blocks Keyboard for Mobile Rewards Games)
    this.triggerAARPExternalEvent();
  };

  addDynamicStyles() {
    const style = document.createElement('style');
    style.id = 'dynamic-styles';
    style.innerHTML = `
      @media (max-width: 768px) {
        .player-ark-aarp-container {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
  
        #video_container {
          position: fixed !important;
          top: 0 !important;
          height: 100vh !important;
          z-index: 99999;
        }
      }
    `;
    document.head.appendChild(style);
  }

  removeDynamicStyles() {
    const style = document.getElementById('dynamic-styles');
    if (style) {
      style.remove();
    }
  }

  componentDidMount() {
    this.checkAuth();
    this.getScoreBox();
    this.getCrossPromotion();
    this.getEngagementPromotion();
    this.getPreviewMode();

  if (isMobileDevice()) {
    this.addDynamicStyles();
  }

    window.addEventListener("message", this.receiveMessage);
    if (this.props.gameState !== GameState.GAME) {
      BadgeService.updateBadgeStatus();
    }
  }

  componentWillUnmount() {
    this.props.dispatch(setGameState(GameState.PENDING));
    window.removeEventListener("message", this.receiveMessage);
    this.removeDynamicStyles();
  }

  private shouldUpdatePromotions(prevProps: GameContainerProps): boolean {
    const { user, gameState, game } = this.props;
    const userChanged = prevProps.user !== user;
    const gameChanged = prevProps.game.slug !== game.slug;
    const gameSavedScore =
      prevProps.gameState !== gameState &&
      gameState === GameState.GAME_SCORE_SAVED;
    return gameChanged || userChanged || gameSavedScore;
  }

  private shouldResizeGameArea(prevProps: GameContainerProps): boolean {
    const { gameState } = this.props;
    return (
      prevProps.gameState !== gameState &&
      (gameState === GameState.GAME || gameState === GameState.REWARD)
    );
  }

  componentDidUpdate(prevProps: GameContainerProps) {
    const { user, gameState, game, userAuthStatus } = this.props;
    const authStatusChanged = userAuthStatus !== prevProps.userAuthStatus;
    const gameStarted =
      prevProps.gameState !== gameState && gameState === GameState.GAME;
    const gameChanged = prevProps.game.slug !== game.slug;

    if (authStatusChanged) {
      this.checkAuth();
    }

    if (gameChanged) {
      this.props.dispatch(setGameState(this.getDefaultState()));
    }

    if (this.shouldUpdatePromotions(prevProps)) {
      this.getScoreBox();
      this.getCrossPromotion();
      this.getEngagementPromotion();
      this.getPreviewMode();
    }

    // Do not save game as played, if player actually did not played it
    if (gameStarted && !(game.membersOnly && !UserService.isValidMember(user))) {
        RecentlyPlayedService.trackGameStart(game, user);
    }

    if (this.shouldResizeGameArea(prevProps)) {
      this.onGrmResize();
    }

    // TODO:[Stanislav Tkachenko] this line causes issue with rewards badge, please find appropriate fix
    if (gameChanged) {
      BadgeService.updateBadgeStatus();
    }
  }

  getHighScore(): number {
    const scoreBox = this.props.scoreBox;
    let highScore;

    if (scoreBox) {
      highScore = scoreBox.userAllTime;
    } else {
      const localScores = LocalScoreService.getScores();
      highScore = localScores[this.props.game.groupSlug];
    }

    return Math.max(highScore, this.state.score);
  }

  onPlatformSpecificEvent = (baseEvent: MessageEvent) => {
    const event: MessageEvent | TypeGameEvent = baseEvent.data;

    const { type } = (event as TypeGameEvent) || {};

    if (!type) {
      return;
    }

    try {
      switch (type) {
        case EnumIframeMessageTypes.TEST_READY:
          this.onGameLoad();
          break;
        case EnumIframeMessageTypes.GAME_END:
          document.body.style.overflow = "auto";
          this.onGameEnd(event);
          break;
        case EnumIframeMessageTypes.CHANGE_SCORE:
          this.onScoreChange(event);
          break;
        case EnumIframeMessageTypes.REWARD_START:
          this.onReward(event);
          break;
        case EnumIframeMessageTypes.REDEEM_POWERUP:
          this.onPowerUp(event);
          break;
        case EnumIframeMessageTypes.OPT_LOG_IN:
          this.onOptInLogin(event);
          break;

        default:
          break;
      }
    } catch (e) {
      console.error(e);
    }
  };

  grmIsUsed(): boolean {
    const { game } = this.props;
    if (isServer) {
      return false;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const grmParam = urlParams.get("__grm");

    if (grmParam === "true") {
      return true;
    }

    if (grmParam === "false") {
      return false;
    }

    return game.isGRM;
  }

  isAARPNow(): boolean {
    if (typeof window === 'undefined') return false;
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("EXP") === "aarp_now";
  }

  //These classes fix the issue with GRM games not being full screen when in mobile
  calculateCustomClassesForGRM = () => {
    const { gameState } = this.props;
    const shouldHide = [GameState.PREROLL, GameState.REWARD].includes(
      gameState
    );
    const isPhone = isMobile();
    const isTablet = isMobileDevice() && !isPhone;

    const addConditionally = (condition: boolean, style: string) =>
      condition ? [style] : [];

    return {
      customCssClassesUnitContainer: [
        styles.gameUnitContainer,
        ...addConditionally(shouldHide, styles.hidden),
        ...addConditionally(isMobileDevice(), styles.fullScreen),
      ],
      customCssClassesCanvasContainer: [
        styles.unitCanvasContainer,
        ...addConditionally(shouldHide, styles.hidden),
        ...addConditionally(isPhone, styles.fullScreenMob),
        ...addConditionally(isTablet, styles.fullScreenTab),
        ...addConditionally(isMobileDevice(), styles.fullscreenMobile),
      ],
      customCssClassesCanvasBoxWrapper: [],
      customCssClassesCanvasBox__common: ["game", styles.canvasBox],
      customCssClassesCanvasBox__iframe: ["game", styles.canvasBox],
    };
  };

  //This function is used only for GRM - this calculates the height of the game canvas and sets it
  onGrmResize = () => {
    const element = this.gameContainerRef.current as any;
    const unitContainer = document.querySelector(
      '[class*="Game-module__unitContainer"]'
    ) as HTMLDivElement;
    let componentHeight: number;

    if (!element || !unitContainer || isServer) {
      return;
    }

    if (isMobileDevice()) {
      window.scrollTo(0, 0);
      document.body.style.overflow = "hidden";
      componentHeight = window.innerHeight;
      this.setState({ isLandscape: isLandscape() });
    } else {
      document.body.style.overflow = "auto";
      const parent = element.parentNode.parentNode;
      const width = parent.offsetWidth;
      const AARP_STICKY_HEADER_HEIGHT = 60;
      const GRAY_BAR_AREA_CONTENT = 100;
      const gameAspectRatio = getAspectRatioByGame(this.props.game.slug);
      componentHeight = Math.min(
        Math.ceil(width * gameAspectRatio),
        window.innerHeight - AARP_STICKY_HEADER_HEIGHT - GRAY_BAR_AREA_CONTENT
      );
    }

    const isGame = this.props.gameState === GameState.GAME;
    if (isMobileDevice() || !isGame) {
      unitContainer.style.height = `auto`;
      unitContainer.style.position = "absolute";
    } else {
      unitContainer.style.height = `${componentHeight}px`;
      unitContainer.style.position = "relative";
    }
  };

  handlerLogin() {
    location.href = AARPAuthService.getNewLoginUrl();
  }

  handlerRegister() {
    location.href = AARPAuthService.getRegisterUrl();
  }

  loginModal() {
    return (
      <Modal
        modalTheme="secondary"
        header="AARP REGISTERED USER FEATURE"
        headerTitle="Log in to play in full-width Theater Mode"
        footerText="Not Registered? Create Account >"
        content="Best used before game start to save your game progress"
        onClose={() => this.handlerCloseLoginModal()}
        onConfirm={() => this.handlerLogin()}
        footerClick={() => this.handlerRegister()}
        confirmButtonText="Log In"
        isSectionModal
      />
    );
  }

  setIsTheaterMode = async () => {
    await this.props.dispatch(setTheaterMode(!this.props.isTheaterMode));
    handlerADContent({ isTheaterMode: this.props.isTheaterMode });
    this.onGrmResize();
  };

  handlerCloseLoginModal() {
    this.setState({ showLoginModal: false });
  }

  //Resize for theater mode only for GRM
  onGrmResizeClick = () => {
    const { game, isTheaterMode, user } = this.props;

    Analytics.trackEvent(
      Analytics.games.theaterModeClick(game, !isTheaterMode)
    );

    const element = document.getElementById("game_container");
    if (user) {
      if (element && !isTheaterMode) {
        window.scrollTo({ top: element.scrollHeight });
      }
      this.setIsTheaterMode();
      this.handlerCloseLoginModal();
    } else {
      this.setState({ showLoginModal: true });
    }
  };

  onUnitUnmount = () => {
    this.props.dispatch(setTheaterMode(false));
  };

  grmGetEnvName = (): TypeEnvType => {
    return environment.AARP_ENV as TypeEnvType;
  };

  getGameUnitProps = (): GRMProps => {
    const { gameState, game, user, isDisplayAdsEnabled } = this.props;
    //For analytics purposes, don't change to games.aarp.org
    const arenaDomain = 'AARP';
    const arenaEnvironment = ARENA_ENV[environment.AARP_ENV as keyof typeof SDK_ENV];

    let gameUnitPropsGRM: GRMProps;

      gameUnitPropsGRM = {
        //@ts-ignore
        game,
        isStateGame: gameStates.includes(gameState),
        isStateGamePlaying: gameState === GameState.GAME,
        arenaDomain: arenaDomain,
        arenaEnvironment: arenaEnvironment,
        isServer: isServer,
        isIframeGame: true,
        currentLang: game.isSpain() ? "es" : "en",
        adFree: isDisplayAdsEnabled,
        user: user as unknown as TypeUserModel,
        addEventHandlers: {},
        doSetGameObservable: this.doSetGameObservable,
        onGameTestReady: this.onGameLoad,
        onGameEnd: this.onGameEnd,
        onScoreChange: this.onScoreChange,
        onRewardStart: this.onReward,
        onPlatformSpecificEvent: this.onPlatformSpecificEvent,
        ...this.calculateCustomClassesForGRM(),
        onResize: this.onGrmResize,
        onUnitUnmount: this.onUnitUnmount,
        env: this.grmGetEnvName(),
        eaglePassedInGame: false, //AARP doesn't have EAGLE Auth
        rewardVideoAvailable: game.seo_IsSupportRewardVideo,
        doOpenMenuLogin: this.handlerLogin,
        doAdsRefresh: () => {},
      };
    

    return gameUnitPropsGRM;
  };

  //This is the new GRM module - renders the old Game Unit or the new GRM iframe with the theater mode and AARP login modal
  grmRenderWrapper = () => {
    const { gameState, game, isTheaterMode, user, isDisplayAdsEnabled } = this.props;
    const { showLoginModal, isPhone, isLandscape } = this.state;

    const grmIsUsed = this.grmIsUsed();
    const hasSavedScore = game.seo_PreventGameEndOnSavedScore;
    
    // Base states for all modes
    const baseStates = [GameState.GAME, GameState.REWARD];

    // Non-GRM gets PREROLL (and optionally GAME_SCORE_SAVED)
    const nonGrmStates = hasSavedScore
      ? [...baseStates, GameState.GAME_SCORE_SAVED, GameState.PREROLL]
      : [...baseStates, GameState.PREROLL];

    // GRM does not get PREROLL (but may get GAME_SCORE_SAVED)
    let grmStates;

    // hard code word clash rendering with preroll to avoid game be recognize as heavy ad by chrome
    if (game.slug === 'word-clash') {
      if (hasSavedScore) {
        grmStates = [...baseStates, GameState.GAME_SCORE_SAVED, GameState.PREROLL];
      } else {
        grmStates = [...baseStates, GameState.PREROLL];
      }
    } else {
      // For all other games
      if (hasSavedScore) {
        grmStates = [...baseStates, GameState.GAME_SCORE_SAVED];
      } else {
        grmStates = [...baseStates];
      }
    }

    const isGameState = (grmIsUsed ? grmStates : nonGrmStates).includes(gameState);

    const isDisplayAdsVisible =
      isDisplayAdsEnabled && isPhone && gameState === GameState.GAME;

    if (!isGameState) {
      return null;
    }

    const gameUnitProps: GRMProps = this.getGameUnitProps();

    return grmIsUsed ? (
      <>
        <GameRenderingModule {...(gameUnitProps as GRMProps)} />
        {isDisplayAdsVisible && (
          <GameAd data-element-description="game top ad">
            <GameMobileAd
              componentId="ark_display_m1"
              dataElementDescription="ark-display-m1"
              dimensions={isLandscape ? [[320, 50]] : [[320, 100]]}
            />
          </GameAd>
        )}
        {!isMobileDevice() &&
          gameState === GameState.GAME &&
          window.innerWidth > ThemeSettings.breakPoints.desktop &&
          game.seo_TheaterMode && (
            <ResizeBox
              isTheaterMode={isTheaterMode}
              user={user}
              onResizeClick={this.onGrmResizeClick}
            />
          )}
        {showLoginModal && this.loginModal()}
      </>
    ) : (
      <GameUnit
        key={game.id}
        isDisplayAdsEnabled
        user={user}
        game={game}
        gameState={gameState}
        onScoreChange={this.onScoreChange}
        onGameEnd={this.onGameEnd}
        onReward={this.onReward}
        onPowerUp={this.onPowerUp}
        onOptInLogin={this.onOptInLogin}
      />
    );
  };

  private renderModals(): JSX.Element | null {
    const {
      showRewardVideoModal,
      showMemberOnlyModal,
      showLoginPowerUpModal,
      showOptInToRewardModal,
    } = this.state;
  
    return (
      <>
        {showRewardVideoModal && this.rewardVideoModal()}
        {showMemberOnlyModal && this.memberOnlyModal()}
        {showLoginPowerUpModal && this.loginPowerUpModal()}
        {showOptInToRewardModal && this.optInToRewardModal()}
      </>
    );
  }

  private renderGameEnd(): JSX.Element | null {
    const { gameState, game, user } = this.props;
    const { crossPromotion, engagementPromo, isSaveScoreToLeaderboard, score, scoreToShow } =
      this.state;
  
    const gameEndState = game.seo_PreventGameEndOnSavedScore
      ? [GameState.GAME_END]
      : [GameState.GAME_END, GameState.GAME_SCORE_SAVED];        
  
    if (gameEndState.includes(gameState)) {
      return (
        <GameEnd
          isGameScoreHacked={isGameScoreHacked}
          game={game}
          score={!isSaveScoreToLeaderboard ? scoreToShow : score}
          highScore={this.getHighScore()}
          isUserAuthorized={UserService.isUserAuthorized(user)}
          isSaveScoreToLeaderboard={isSaveScoreToLeaderboard}
          crossPromotion={crossPromotion}
          engagementPromo={engagementPromo}
        />
      );
    }
  
    return null;
  }

  private renderGameCover(): JSX.Element | null {
    const { gameState, game } = this.props;
    const { previewMode } = this.state;

    if ([
        GameState.COVER_MEMBER,
        GameState.COVER_PREVIEW_MODE,
        GameState.COVER_SKIP_PREROLL,
      ].includes(gameState)
    ) {
      return <GameCover
        game={game}
        gameState={gameState}
        previewMode={previewMode}
      />;
    }
  
    return null;
  }

  private renderPreroll(): JSX.Element | null {
    const { gameState, game } = this.props;

    if (gameState === GameState.PREROLL) {
      return (
        <ContainerPreroll>
          <Ribbon size="large" game={game} className={styles.gameCoverRibbon} />
          <RewardLabel size="large" game={game} />
          <Preroll
            game={game}
            posterLink={checkFullPath(
              game.assetOriginUrl,
              game.promoThumbPath
            ).toString()}
            onEnd={this.onPrerollEnd}
          />
        </ContainerPreroll>
      );
    }

    return null;
  }

  render() {
    const { gameState, game } = this.props;
    const {
      previewMode,
    } = this.state;
    const gameUnitStates = game.seo_PreventGameEndOnSavedScore
      ? [GameState.GAME, GameState.REWARD, GameState.GAME_SCORE_SAVED]
      : [GameState.GAME, GameState.REWARD];
    const isInterstitialState = gameState === GameState.INTERSTITIAL; //For future compatibility

    return (
      <>
        <Container data-element-description="game" ref={this.gameContainerRef} id="game_container">
          {isMobileDevice() && (
            <MobileQuery>
              {(gameState === GameState.GAME ||
                (game.seo_PreventGameEndOnSavedScore &&
                  gameState === GameState.GAME_SCORE_SAVED)) && (
                <MobileStyles />
              )}
            </MobileQuery>
          )}

          {this.isAARPNow() && <MobileStyles />}

          {this.renderGameCover()}

          {this.renderPreroll()}

          {gameState === GameState.REWARD && (
            <ContainerRewardVideo>
              <RewardVideo game={game} onEnd={this.onRewardEnd} />
            </ContainerRewardVideo>
          )}

          {gameUnitStates.indexOf(gameState) !== -1 &&
            gamesListForDataAnalytics.includes(game.slug) && (
              <AnalyticsAttribute hidden={true} />
            )}

          {this.grmRenderWrapper()}
          {this.renderModals()}
          {this.renderGameEnd()}
        </Container>
        {gameState === GameState.COVER_PREVIEW_MODE && (
          <Banner
            dangerouslySetInnerHTML={{ __html: previewMode.bannerHtml }}
          />
        )}
      </>
    );
  }
}

export const GameContainer = connect((state: RootState) => ({
  gameState: state.gameState,
  scoreBox: state.scoreBox,
  userAuthStatus: state.userAuthStatus,
  scoreFilter: state.scoreFilter,
  isTheaterMode: state.isTheaterMode,
  gamePreviews: state.gamePreviews,
  sdkLoaded: state.sdkLoaded,
}))(GameContainerDumb);

const MobileStyles = (props: any) => (
  <style>
    {`
        .aarp-c-header {
            z-index: 0 !important;
            display: none !important;
        }
        .aarp-c-footer {
            z-index: 0 !important;
            display: none !important;
        }
    `}
  </style>
);

const Container = React.forwardRef<any, any>((props: any, ref: any) => {
  return (
    <div className={classNames(styles.gameContainer)} {...props} ref={ref} />
  );
});

const ContainerPreroll = (props: any) => (
  <div className={styles.containerPreroll} {...props} />
);
const ContainerRewardVideo = (props: any) => (
  <div className={styles.containerRewardVideo} {...props} />
);
const Banner = (props: any) => <div className={styles.banner} {...props} />;

const GameAd = (props: any) => <div className={styles.gameAd} {...props} />;

const gamesListForDataAnalytics = [
  "aarp-trivia",
  "lets-crossword",
  "aarp-trivia-sports",
];
